import React, { useState } from "react";
import Swal from "sweetalert2";
import LicenciaSelect from "./LicenciaSelect";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";

const CadeteForm = ({ cadete, onClose }) => {

const Usuario=ObtieneDatosCookies()
  

  const [valor, setValor] = useState('');

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Solo permitimos letras (de la A a la Z, mayúsculas o minúsculas)
    if (/^[A-Za-z]*$/.test(inputValue)) {
      setValor(inputValue);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Validar solo letras para el campo cadeteDomicilio
    if (name === "cadeteDomicilio" && !/^[A-Za-z\s]*$/.test(value)) {
      return; // Si no cumple con el patrón, no actualizamos el estado
    }

    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const muestroFoto = (valor) => {
    window.open('https://wwwa.isepsantafe.net.ar/imagenes/' + valor)
  }
  const manejarCambioLicencia = (nuevoValor) => {
    setFormData((prevData) => ({
      ...prevData,
      cadeteLicencia: nuevoValor,
    }));
  };
  const [formData, setFormData] = useState({ ...cadete });
  const handleReempadronar = () => {
    const { cadeteCiudad, cadeteCria, cadeteCelular, cadeteUR, cadeteCuil, cadeteEmail, cadeteGenero, cadeteGrupoSanguineo, cadetePadre, cadeteMadre, domicilioNumero, cadeteLicencia } = formData;
    const formControls = document.querySelectorAll(".form-control");
    const hasInvalidFields = Array.from(formControls).some((input) =>
      input.classList.contains("is-invalid")
    );

    if (hasInvalidFields) {
      Swal.fire({
        title: "Error",
        text: "Por favor, corrige los campos en rojo.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }
    if (!cadeteCiudad || !cadeteCria || !cadeteCelular || !cadeteUR || !cadeteCuil || !cadeteEmail || !cadeteGenero || !cadeteGrupoSanguineo || !cadeteMadre || !cadetePadre || !domicilioNumero) {
      Swal.fire({
        title: "Error",
        text: "Por favor, completa todos los campos requeridos.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    Swal.fire({
      title: "¿Estás seguro?",
      text: "Vas a reempadronar al cadete.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, reempadronar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Reempadronado", "El cadete ha sido reempadronado.", "success");
        if (onClose) onClose(formData);
      }
    });
  };

  const handleCancel = () => {
    Swal.fire({
      title: "¿Cancelar cambios?",
      text: "Se perderán todos los cambios no guardados.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cancelar",
      cancelButtonText: "Continuar editando",
    }).then((result) => {
      if (result.isConfirmed) {
        if (onClose) onClose();
      }
    });
  };
  const today = new Date();

  // Calcular la fecha mínima: 18 años atrás
  const minDate = new Date(today);
  minDate.setFullYear(today.getFullYear() - 18);

  // Formatear la fecha a 'YYYY-MM-DD' para el valor del input
  const minDateString = minDate.toISOString().split('T')[0];

  return (
    <div style={{ maxHeight: "550px", maxWidth: "1000px", overflowY: "auto", border: "1px solid #ccc", padding: "10px" }}>
  
  <form style={{ textAlign: "center" }}>
     <div style={{overflow:"auto"}}>
      <div className="input-group-text" style={{ display: "flex", width: "100%",justifyContent: "space-around" }}>
        <div className="d-flex justify-content-center gap-3 mb-3">
          <img
            src={`https://wwwa.isepsantafe.net.ar/imagenes/${formData.fotoCadete}`}
            alt="Foto Cadete"
            className="rounded-circle border"
            style={{ height: "75px", width: "75px", cursor: "pointer" }}
            onClick={() => muestroFoto(formData.fotoCadete)}
          />
          <img
            src={`https://wwwa.isepsantafe.net.ar/imagenes/${formData.fotoFrenteDni}`}
            alt="Foto Frente DNI"
            className="border"
            style={{ height: "90px", width: "120px", objectFit: "cover" }}
            onClick={() => muestroFoto(formData.fotoFrenteDni)}
          />
          <img
            src={`https://wwwa.isepsantafe.net.ar/imagenes/${formData.fotoReversoDni}`}
            alt="Foto Reverso DNI"
            className="border"
            style={{ height: "90px", width: "120px", objectFit: "cover" }}
            onClick={() => muestroFoto(formData.fotoReversoDni)}
          />
        </div><div> <h3 style={{color:"green",}}>{cadete.cadeteCondicion}</h3></div>
       
          <div className="">
            <label>DNI</label>
            <input
              type="number"
              name="cadeteDni"
              value={formData.cadeteDni || ""}
              className="form-control"
              disabled
            />
          </div>
          <div id="Sede" className="">
            <label>Sede</label>
            <select
              name="cadeteSede"
              value={formData.cadeteSede || ""}
              onChange={handleInputChange}
              required
              disabled={Usuario.nivel == "3"||Usuario.nivel == "4"}
              className={`form-select ${!formData.cadeteSede ? "is-invalid" : "is-valid"
                }`}
            >
              <option value="">Seleccionar...</option>

              <option value="Recreo">Recreo</option>
              <option value="Rosario">Rosario</option>



            </select>
          </div>
        </div>

        <div className="input-group-text" style={{ display: "flex", width: "100%",justifyContent: "space-around" }}>
        <div className="">
            <label>Apellido Completo</label>
            <input
              type="text"
              name="cadeteApellido"
              value={formData.cadeteApellido || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.cadeteApellido ? "is-invalid" : "is-valid"
                }`}
            />
          </div>
          <div className="">
            <label>Nombre Completo</label>
            <input
              type="text"
              name="cadeteNombre"
              value={formData.cadeteNombre || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.cadeteNombre ? "is-invalid" : "is-valid"
                }`}
            />
          </div>
          <div id="CUIL" className="">
            <label>CUIL</label>
            <input
              type="text"
              name="cadeteCuil"
              value={formData.cadeteCuil || ""}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/g, ""); // Remueve todo lo que no sea un dígito
                handleInputChange({
                  target: {
                    name: e.target.name,
                    value: numericValue,
                  },
                });
              }}
              onBlur={(e) => {
                const isValidLength = e.target.value.length === 11; // Valida longitud de 10
                if (!isValidLength) {
                  handleInputChange({
                    target: {
                      name: e.target.name,
                      value: "", // Limpia el valor si no es válido
                    },
                  });
                }
              }}
              required
              maxLength={11}
              className={`form-control ${formData.cadeteCuil?.length === 11 ? "is-valid" : "is-invalid"
                }`}
            />
          </div>
          <div id="Género" className="">
            <label>Género</label>
            <select
              name="cadeteGenero"
              value={formData.cadeteGenero || ""}
              onChange={handleInputChange}
              required
              className={`form-select ${!formData.cadeteGenero ? "is-invalid" : "is-valid"
                }`}
            >
              <option value="">Seleccionar...</option>

              <option value="Masculino">Masculino</option>
              <option value="Femenino">Femenino</option>
              <option value="X">X</option>


            </select>
          </div>
          <div id="Fecha Nacimiento" className="">
            <label>Fecha Nacimiento</label>
            <input
            type="date"
              name="fechaNacimiento"
              value={formData.fechaNacimiento || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.fechaNacimiento ? "is-invalid" : "is-valid"
                }`}
            /></div>
          </div>
          <div className="input-group-text" style={{ display: "flex", width: "100%",justifyContent: "space-around" , alignItems:"flex-end"}}>
          <div><h6 >Domicilio DNI</h6>
          <div className="input-group-text" style={{ display: "flex", width: "100%",justifyContent: "space-around" }}>






              <div className="" style={{ width: "200px" }} >
                <label>Calle </label>
                <input
                  type="text"
                  name="cadeteDomicilio"
                  value={formData.cadeteDomicilio || ""}
                  onChange={handleInputChange}
                  required
                  placeholder="Solo letras"
                  className={`form-control ${!formData.cadeteDomicilio ? "is-invalid" : "is-valid"}`}
                />


              </div>
              <div id="Nro Domicilio DNI" className="" style={{ width: "105px" }}>
                <label>Nro</label>
                <input
                  type="number"
                  name="domicilioNumero"
                  value={formData.domicilioNumero || ""}
                  onChange={(e) => {
                    // Permitir solo dígitos
                    const numericValue = e.target.value.replace(/\D/g, ""); // Remueve caracteres no numéricos
                    handleInputChange({
                      target: {
                        name: e.target.name,
                        value: numericValue,
                      },
                    });
                  }}
                  onBlur={(e) => {
                    const isValidLength = e.target.value.length > 0; // Valida que no esté vacío
                    if (!isValidLength) {
                      // Si no es válido, limpia el valor y actualiza el estado
                      handleInputChange({
                        target: {
                          name: e.target.name,
                          value: "", // Reinicia a vacío si no es válido
                        },
                      });
                    }
                  }}
                  required
                  className={`form-control ${formData.domicilioNumero?.length > 0 ? "is-valid" : "is-invalid"
                    }`}
                />
              </div>

              <div className="" style={{ width: "105px" }}>
                <label>Piso</label>
                <input
                  type="text"
                  name="domicilioPiso"
                  value={formData.domicilioPiso || ""}
                  onChange={handleInputChange}

                  className={`form-control ${!formData.domicilioPiso ? "is-invalid" : "is-valid"
                    }`}
                />
              </div>
              <div className="" style={{ width: "105px" }}>
                <label>Dpto</label>
                <input
                  type="text"
                  name="domicilioDpto"
                  value={formData.domicilioDpto || ""}
                  onChange={handleInputChange}

                  className={`form-control ${!formData.domicilioDpto ? "is-invalid" : "is-valid"
                    }`}
                />
              </div>
            </div>
          </div>
          <div className="input-group-text" style={{ display: "flex", width: "100%",justifyContent: "space-around" }}>
          <div className="">
            <label>Ciudad</label>
            <input
              type="text"
              name="cadeteCiudad"
              value={formData.cadeteCiudad || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.cadeteCiudad ? "is-invalid" : "is-valid"
                }`}
            />
          </div>
          <div className="" style={{width:"120px"}}>
            <label>Codigo Postal</label>
            <input
              type="text"
              name="codigoPostal"
              value={formData.codigoPostal || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.codigoPostal ? "is-invalid" : "is-valid"
                }`}
            />
          </div>
          <div className="">
            <label>Domicilio Alternativo</label>
            <input
              type="text"
              name="cadeteDomicilioAlternativo"
              value={formData.cadeteDomicilioAlternativo || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.cadeteDomicilioAlternativo ? "is-invalid" : "is-valid"
                }`}
            />
          </div>



        </div>
        </div>
        <div className="input-group-text" style={{ display: "flex", width: "100%",justifyContent: "space-around" }}>
        


          <div id="Departamento" className="">
            <label>Departamento</label>
            <select
              name="cadeteUR"
              value={formData.cadeteUR || ""}
              onChange={handleInputChange}
              required
              className={`form-select ${!formData.cadeteUR ? "is-invalid" : "is-valid"
                }`}
            >
              <option value="">Seleccionar...</option>

              <option value="La Capital">La Capital</option>
              <option value="Rosario">Rosario</option>
              <option value="Belgrano">Belgrano</option>
              <option value="Caseros">Caseros</option>
              <option value="Castellanos">Castellanos</option>
              <option value="Constitución">Constitución</option>
              <option value="Garay">Garay</option>
              <option value="General López">General López</option>
              <option value="General Obligado">General Obligado</option>
              <option value="Iriondo">Iriondo</option>
              <option value="Las Colonias">Las Colonias</option>
              <option value="Nueve de Julio">Nueve de Julio</option>
              <option value="San Cristóbal">San Cristóbal</option>
              <option value="San Javier">San Javier</option>
              <option value="San Jerónimo">San Jerónimo</option>
              <option value="San Justo">San Justo</option>
              <option value="San Lorenzo">San Lorenzo</option>
              <option value="San Martín">San Martín</option>
              <option value="Vera">Vera</option>
            </select>
          </div>
          <div id="Comisaría" style={{ width: "120px" }} className="">
            <label>Comisaría</label>
            <input
              type="text"
              name="cadeteCria"
              value={formData.cadeteCria || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.cadeteCria ? "is-invalid" : "is-valid"
                }`}
            />

          </div>
          
          <div id="Grupo Sanguineo" className="">
            <label>Grupo Sanguineo</label>
            <select
              name="cadeteGrupoSanguineo"
              value={formData.cadeteGrupoSanguineo || ""}
              onChange={handleInputChange}
              required
              className={`form-select ${!formData.cadeteGrupoSanguineo ? "is-invalid" : "is-valid"
                }`}
            >
              <option value="">Seleccionar...</option>

              <option value="O+">O+</option>
              <option value="O-">O-</option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>

            </select>
          </div>


          <div id="Datos Padre" className="" style={{ width: "270px" }}>
            <label>Datos Padre</label>
            <input
              type="text"
              name="cadetePadre"
              value={formData.cadetePadre || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.cadetePadre ? "is-invalid" : "is-valid"}`}
            />
          </div>
          <div id="Datos Madre" className="" style={{ width: "270px" }}>
            <label>Datos Madre</label>
            <input
              type="text"
              name="cadeteMadre"
              value={formData.cadeteMadre || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.cadeteMadre ? "is-invalid" : "is-valid"}`}
            />
          </div>

     
         
        </div>
      <div className="input-group-text" style={{width:"100%",display:"flex",textAlign:"center",alignContent:"space-around",alignItems:"center", justifyContent:"center"}}> 
        <div id="email-field" className="" style={{ width: "450px",  }}>
  <label>Email</label>
  <input
    type="email"
    name="cadeteEmail"
    value={formData.cadeteEmail || ""}
    onChange={(e) => {
      handleInputChange(e);
    }}
    onBlur={(e) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Expresión regular para validar correo
      const isValidEmail = emailRegex.test(e.target.value);
      if (!isValidEmail) {
        handleInputChange({
          target: {
            name: e.target.name,
            value: "", // Reinicia si no es un email válido
          },
        });
      }
    }}
    required
    className={`form-control ${formData.cadeteEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.cadeteEmail)
      ? "is-valid"
      : "is-invalid"
      }`}
  />
</div>

          <div id="Celular" className="" style={{ width: "270px" }}>
            <label>Celular</label>
            <input
              type="text"
              name="cadeteCelular"
              value={formData.cadeteCelular || ""}
              onChange={handleInputChange}
              required
              className={`form-control ${!formData.cadeteCelular ? "is-invalid" : "is-valid"}`}
            />
          </div>


</div>
        <>
<div>
  Licencia de Conducir
</div>
          <LicenciaSelect
            licenciaInicial={cadete.cadeteLicencia}
            onChange={manejarCambioLicencia}
          />


        </>
        </div>
        <div className="">
          <button
            type="button"
            className="btn btn-primary me-2"
            onClick={handleReempadronar}
          >
            {formData.cadeteCondicion != "Convocado" ? "Guardar Cambios" : "Reempadronar"}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleCancel}
          >
            Cancelar
          </button>
        </div>
      </form>

    </div>
  );
};

export default CadeteForm;
